export default async($modal, data) => {
  if (data?.component) {
    const modalComponent = (await import(`./../components/Modals/${data.component}.vue`)).default
    const modalProps = data.props
    await $modal.show(modalComponent, modalProps, {
      height: 'auto',
      scrollable: true
    })
  }
}
